import React, {useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"

// components
import DestinationActivityLangs from "./_langs";
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {PH_CODE, PH_IMAGE, PH_ORDER} from "../../../components/i18n/placeHolders"
import {TT_CLOSE, TT_SAVE} from "../../../components/i18n/toolTips";
import {FL_TYPE} from "../../../components/i18n/formLabels";
import {
    LB_CODE, INTERNATIONAL,
    LB_ORDER, LB_STATUS,
    REQUIRED, LB_IMG
} from "../../../components/i18n/i18n"

// services
import {destinationActivityService} from "../../../jwt/_services/xailing/destinationActivityService"

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {typeDestinationActivityProvider} from "../../../providers/typeDestinationActivityProvider";
import {admissionProvider} from "../../../providers/admissionProvider";
import DestinationLags from "../destination/_langs";


const DestinationActivityForm = props => {
    const path = `${props?.path}/activity`;

    const parentComponentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const { domainObject: parent } = parentComponentState?.data || {};
    const { app, udn, editMode, domainObject} = componentState?.data || {};
    const fbDataBase = {id: app?.fbDataBase?.id}

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []
    const [status, setStatus] = useState(domainObject?.status || true);
    const [typeDestinationActivityId, setTypeDestinationActivityId] = useState(domainObject?.type?.id || null);
    const [admissionId, setAdmissionId] = useState(domainObject?.admission?.id || null);

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            image: domainObject?.image,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item: {
                uid: domainObject?.uid,
                ...data,
                langs,
                destination:{ id: parent?.id},
            }
        };

        dataRequest.item.typeDestinationActivity = typeDestinationActivityId ? { id: typeDestinationActivityId } : null;

        dataRequest.item.admission = admissionId ? { id: admissionId } : null;

        if(status !== undefined && status !== null)
            dataRequest.item.status = status;


        if (!editMode)
            genericIndexedActions.save(path, destinationActivityService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, destinationActivityService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.toggle()
    }


    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={ handleSubmit(onSubmit) }>
            <Card className={ 'card-modal-small' }>
                <CardTitle className="bg-light border-bottom mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className="top-right">
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={props.toggle}
                        />
                    </div>
                </CardTitle>
                <CardBody>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                />
                                {errors.code && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_IMG}</Label>
                                <Input
                                    type="text"
                                    name="image"
                                    placeholder={PH_IMAGE}
                                    innerRef={register}
                                />
                                {errors.image && <div className="invalid-feedback"
                                                      style={{'display': 'block'}}>{errors?.image?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_ORDER}</Label>
                                <Input
                                    type="number"
                                    name="showOrder"
                                    placeholder={PH_ORDER}
                                    innerRef={register}
                                />
                                {errors.showOrder && <div className="invalid-feedback"
                                                          style={{'display': 'block'}}>{errors?.showOrder?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{'Activo'}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{FL_TYPE}</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={typeDestinationActivityId}
                                    setExternalValue={setTypeDestinationActivityId}
                                    provider={typeDestinationActivityProvider}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>{'Entrada'}</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={admissionId}
                                    setExternalValue={setAdmissionId}
                                    provider={admissionProvider}
                                    customFilter={{fbDataBase, item: {udn: {id: udn?.id}, allowBuy: true}}}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <div className={'form-container'}>
                        <div className={''}>
                            <h2>{INTERNATIONAL}</h2>
                        </div>
                        <div className={''}>
                            <DestinationActivityLangs langs={langs} setLangs={setlangs}
                                             translatableLangs={domainObject?.translatedLangs || []}/>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Form>
    </Modal>
}
export default DestinationActivityForm